<template>
  <div>
    <z-steps :active="0">
      <z-step
        class="step"
        v-for="(item, index) in horizontal"
        :key="index"
        :title="item.title"
        :image-active="item.imageActive"
        :image-deactive="item.imageDeactive"
      />
    </z-steps>
    <qua-form @handleSubmit="handleSubmit" :btnLoading="loading"/>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Step, Steps, Toast } from '@zz-common/zz-ui'
// import { lego } from '@zz-common/lego'
import { queryParams } from '../../../lib/utils'
import { getbizlicense, submitBizLicense } from '../../../api/resourceApi'
import QuaForm from '../../common/QuaForm'

const query = queryParams()

export default {
  name: 'QualityLicense',
  data() {
    return {
      sourceCode: query.sourceCode || this.$route.query.sourceCode || 'unknow',
      loading: false,
      horizontal: [
        {
          title: '营业执照',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '经营许可',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        },
        {
          title: '提交成功',
          imageActive: '4405898d-8bf9-49ce-97ee-28f8ecf1005d.png',
          imageDeactive: '768707ae-57c8-437e-8f9c-27adc392ed56.png'
        }
      ]
    }
  },
  components: {
    zStep: Step,
    zSteps: Steps,
    QuaForm
  },
  methods: {
    async getDetial() {
      console.log('getDetial-before');
      const { permitStatus, hasLicense } = await getbizlicense() //0未处理1成功2失败  hasLicence代表是否有营业执照
      console.log('getDetial', permitStatus);
      if (permitStatus == 'null' && hasLicense == '1') return this.toPermit() //经营许可
      if (+permitStatus === 0 && hasLicense == '1') return this.toDeal(); //提交成功
      if (+permitStatus === 1 && hasLicense == '1') return this.toSuccess(); //审核成功
      if (+permitStatus === 2 && hasLicense == '1') return this.toPermit();//审核不通过，重新提交许可证
      return ''
    },
    handleSubmit(params) {
      console.log('handleSubmit', params);
      if (this.loading) return;
      const newParams = { ...params, sourceCode: this.sourceCode }
      this.loading = true;
      submitBizLicense(newParams)
        .then((_res) => {
          this.loading = false
          Toast('提交成功')
          this.toPermit();
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    },
    toDeal() {
      setTimeout(() => {
        const targetUrl = 'https://feentry.zhuanzhuan.com/QualityAppeal?clientid=QualitySuccess&status=deal'
        native.skipToUrl({ targetUrl, needClose: '1' })
      }, 300)
    },
    toSuccess() {
      setTimeout(() => {
        const targetUrl = 'https://feentry.zhuanzhuan.com/QualityAppeal?clientid=QualitySuccess&status=success'
        native.skipToUrl({ targetUrl, needClose: '1' })
      }, 300)
    },
    toPermit() {
      setTimeout(() => {
        const targetUrl = `https://feentry.zhuanzhuan.com/QualityAppeal?clientid=QualityPermit&sourceCode=${this.sourceCode}`
        native.skipToUrl({ targetUrl, needClose: '1' })
      }, 300)
    }
  },
  mounted() {
    console.log('mounted');
    native.setTitle({
      title: '资质提交'
    })
    console.log('setTitle');
    this.getDetial()
  }
}
</script>

<style lang="less">
  @import 'index.less';
</style>
